<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";

/**
 * Home / Inicio rápido — lanzador empresarial de módulos.
 */
export default {
  page: {
    title: "Inicio",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      // Accesos rápidos a los módulos (rutas reales del router).
      accesos: [
        { name: "nuevaVenta", title: "Nueva Venta", sub: "Registrar venta", color: "c-blue", icon: "cart" },
        { name: "ventas", title: "Ventas", sub: "Listado de ventas", color: "c-blue", icon: "list" },
        { name: "cotizacionVenta", title: "Cotizaciones", sub: "Crear cotización", color: "c-blue", icon: "file" },
        { name: "creditosVenta", title: "Créditos", sub: "Créditos de venta", color: "c-indigo", icon: "card" },
        { name: "newCompra", title: "Nueva Compra", sub: "Registrar compra", color: "c-green", icon: "bag" },
        { name: "compras", title: "Compras", sub: "Listado de compras", color: "c-green", icon: "list" },
        { name: "productos", title: "Productos", sub: "Inventario", color: "c-amber", icon: "box" },
        { name: "traslados", title: "Traslados", sub: "Entre bodegas", color: "c-amber", icon: "transfer" },
        { name: "diagnosticoTaller", title: "Diagnóstico", sub: "Orden de taller", color: "c-red", icon: "gear" },
        { name: "taller", title: "Taller", sub: "Servicios", color: "c-red", icon: "wrench" },
        { name: "inicioCaja", title: "Inicio Caja", sub: "Abrir caja", color: "c-teal", icon: "wallet" },
        { name: "corteCaja", title: "Corte de Caja", sub: "Cierre y corte", color: "c-teal", icon: "money" },
        { name: "clientes", title: "Clientes", sub: "Directorio", color: "c-indigo", icon: "user" },
        { name: "ganancias", title: "Ganancias", sub: "Reportes", color: "c-indigo", icon: "chart" },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <div class="home">
      <!-- ===== Hero de bienvenida ===== -->
      <div class="home-hero">
        <div class="home-hero__text">
          <h1>Bienvenido 👋</h1>
          <p>
            Panel de control · Taller Ariel — accede rápido a tus módulos de
            trabajo.
          </p>
        </div>
        <div class="home-hero__logo">
          <img src="/logo.jpeg" alt="Taller Ariel" />
        </div>
      </div>

      <!-- ===== Accesos rápidos ===== -->
      <h2 class="home-sectitle">Accesos rápidos</h2>
      <div class="home-grid">
        <router-link
          v-for="a in accesos"
          :key="a.name + a.title"
          class="home-tile"
          :to="{ name: a.name }"
        >
          <span class="home-tile__ic" :class="a.color">
            <!-- iconos inline (no dependen de fuentes externas) -->
            <svg v-if="a.icon === 'cart'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h2l2 13h11l2-8H7" /><circle cx="9" cy="20" r="1" /><circle cx="18" cy="20" r="1" /></svg>
            <svg v-else-if="a.icon === 'list'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16M4 12h16M4 19h10" /></svg>
            <svg v-else-if="a.icon === 'file'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h4" /></svg>
            <svg v-else-if="a.icon === 'card'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2" /><path d="M2 10h20" /></svg>
            <svg v-else-if="a.icon === 'bag'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 11H6z" /><path d="M9 8V6a3 3 0 0 1 6 0v2" /></svg>
            <svg v-else-if="a.icon === 'box'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7l9-4 9 4-9 4z" /><path d="M3 7v10l9 4 9-4V7" /></svg>
            <svg v-else-if="a.icon === 'transfer'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h13l-3-3M20 15H7l3 3" /></svg>
            <svg v-else-if="a.icon === 'gear'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 13a7.5 7.5 0 0 0 0-2l2-1.5-2-3.5-2.3 1A7 7 0 0 0 15 5.5l-.4-2.5h-4l-.4 2.5a7 7 0 0 0-2.1 1.2l-2.3-1-2 3.5 2 1.5a7.5 7.5 0 0 0 0 2l-2 1.5 2 3.5 2.3-1A7 7 0 0 0 9 19.5l.4 2.5h4l.4-2.5a7 7 0 0 0 2.1-1.2l2.3 1 2-3.5z" /></svg>
            <svg v-else-if="a.icon === 'wrench'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 6.5a3.5 3.5 0 0 0-4.6 4.6L3 18l3 3 6.9-6.9a3.5 3.5 0 0 0 4.6-4.6L15 12l-3-3z" /></svg>
            <svg v-else-if="a.icon === 'wallet'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="13" rx="2" /><path d="M16 12h2" /></svg>
            <svg v-else-if="a.icon === 'money'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 6H9a3 3 0 0 0 0 6h6a3 3 0 0 1 0 6H7" /></svg>
            <svg v-else-if="a.icon === 'user'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V5M4 19h16M8 16v-5M12 16V8M16 16v-3" /></svg>
          </span>
          <div class="home-tile__txt">
            <h3>{{ a.title }}</h3>
            <span>{{ a.sub }}</span>
          </div>
        </router-link>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.home {
  padding-bottom: 10px;
}

/* ===== Hero ===== */
.home-hero {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  color: #fff;
  padding: 30px 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background: radial-gradient(
      900px 360px at 88% -20%,
      rgba(43, 125, 225, 0.5),
      transparent 60%
    ),
    linear-gradient(135deg, #0a1a33, #0d3a78 60%, #1b6ec2);
  box-shadow: 0 10px 30px rgba(16, 42, 76, 0.18);
}
.home-hero::before {
  content: "";
  position: absolute;
  top: -120px;
  right: 120px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: conic-gradient(
    from 200deg,
    #34c38f,
    #f1b44c,
    #f1734f,
    #f46a6a 120deg,
    transparent 120deg
  );
  -webkit-mask: radial-gradient(
    circle,
    transparent 58%,
    #000 59%,
    #000 72%,
    transparent 73%
  );
  mask: radial-gradient(
    circle,
    transparent 58%,
    #000 59%,
    #000 72%,
    transparent 73%
  );
  opacity: 0.16;
}
.home-hero__text {
  position: relative;
  z-index: 1;
}
.home-hero__text h1 {
  margin: 0;
  font-size: 1.9rem;
  font-weight: 700;
  color: #fff;
}
.home-hero__text p {
  margin: 0.4rem 0 0;
  opacity: 0.85;
  max-width: 520px;
}
.home-hero__logo {
  position: relative;
  flex: 0 0 auto;
  padding: 18px;
}
.home-hero__logo::before {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0) 64%
  );
}
.home-hero__logo img {
  position: relative;
  height: 104px;
  display: block;
  -webkit-mask: radial-gradient(circle at 50% 50%, #000 52%, transparent 72%);
  mask: radial-gradient(circle at 50% 50%, #000 52%, transparent 72%);
}

/* ===== Accesos rápidos ===== */
.home-sectitle {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0b1e3a;
  margin: 26px 4px 14px;
}
.home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
}
.home-tile {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(16, 42, 76, 0.06);
  border: 1px solid #eef1f6;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.15s, transform 0.15s;
}
.home-tile:hover {
  box-shadow: 0 10px 24px rgba(16, 42, 76, 0.12);
  transform: translateY(-2px);
  color: inherit;
}
.home-tile__ic {
  flex: 0 0 46px;
  height: 46px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  color: #fff;
}
.home-tile__ic svg {
  width: 24px;
  height: 24px;
}
.home-tile__txt h3 {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 600;
  color: #15233b;
}
.home-tile__txt span {
  font-size: 0.78rem;
  color: #8593a6;
}

.c-blue {
  background: linear-gradient(135deg, #1b6ec2, #0d4f9e);
}
.c-green {
  background: linear-gradient(135deg, #2ecc71, #22a25a);
}
.c-amber {
  background: linear-gradient(135deg, #f1b44c, #e09b22);
}
.c-red {
  background: linear-gradient(135deg, #f1734f, #e04f2a);
}
.c-teal {
  background: linear-gradient(135deg, #16b1c4, #0d8a99);
}
.c-indigo {
  background: linear-gradient(135deg, #564ab1, #3f3590);
}

@media (max-width: 575.98px) {
  .home-hero {
    flex-direction: column;
    text-align: center;
    padding: 24px;
  }
  .home-hero__logo img {
    height: 84px;
  }
}
</style>
